import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  canvas: {
    marginRight: theme.spacing(-8),
    background: theme.palette.canvas.main,
    marginBottom: theme.spacing(9),
    width: '100%',
    height: 'calc(100vh - 88px)',
    overflow: 'auto',
  },
  plusIcon: {
    display: 'flex',
    border: `0.576px solid ${theme.palette.canvasIcon.main}`,
    width: theme.spacing(5.175),
    height: theme.spacing(5.175),
    color: theme.palette.canvasIcon.main,
    fontWeight: 600,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    cursor: 'pointer',
    pointerEvents: 'auto',
  },
  disabled: {
    color: theme.palette.canvasIcon.main,
    opacity: 0.5,
  },
  cardHeading: {
    color: theme.palette.canvasHeading.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  cardTextContainer: {
    width: '100%',
    margin: theme.spacing(0, 3.6, 3.6, 0),
    '& .labra-buy-aws-cards-container': {
      pointerEvents: 'none',
    },
  },
  canvasContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: theme.spacing(3.5625),
    justifyContent: 'center',
    width: 'auto',
    '& > div': {
      justifyContent: 'center',
    },
  },
  canvasContainerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    background: theme.palette.canvas.main,
    overflow: 'auto',
    padding: theme.spacing(10),
    width: 'fit-content',
  },
  embedCodeContainer: {
    display: 'flex',
    position: 'absolute',
    right: theme.spacing(0),
    padding: theme.spacing(3, 5),
    zIndex: 10,
    '& .Mui-disabled': {
      backgroundColor: '#e2e2e2b5 !important',
      color: '#00000091 !important',
    },
  },
  mediaStyle: {
    width: `${theme.spacing(19.37)} !important`,
    objectFit: 'contain',
  },
  textMediaWrapper: {
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 0, 3, 0),
    marginBottom: theme.spacing(1.5),
  },
}))
